import { HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
	IS_PUBLIC,
	SKIP_CONFLICT_REDIRECT,
	SKIP_ERROR_TOAST,
	SKIP_FORBIDDEN_LOGOUT,
} from '@webapp/auth/interceptors/auth.interceptor';
import { IResponse } from '@webapp/core/interfaces/response.interface';
import { ProtectedService } from '@webapp/core/services/protected.service';
import { map, Observable } from 'rxjs';
import { ApiKey, CreateApiKeyRequest, CreatedApiKey } from '../interfaces/api-keys.interface';

@Injectable({
	providedIn: 'root',
})
export class ApiKeysService extends ProtectedService {
	// The feature shows its own toasts (SKIP_ERROR_TOAST), a 403 means "request
	// made with an API key / missing CSRF" rather than an invalid session
	// (SKIP_FORBIDDEN_LOGOUT; 401 keeps the usual flow) and a 409 means "limit
	// reached", not the Mercado Pago redirect (SKIP_CONFLICT_REDIRECT). Built
	// from a fresh HttpContext and never mutated, so it is safe to share.
	private readonly API_KEYS_CONTEXT = {
		context: new HttpContext()
			.set(IS_PUBLIC, false)
			.set(SKIP_ERROR_TOAST, true)
			.set(SKIP_FORBIDDEN_LOGOUT, true)
			.set(SKIP_CONFLICT_REDIRECT, true),
	};

	list(): Observable<ApiKey[]> {
		return this.http
			.get<IResponse>(`${this.apiUrl}users/me/api-keys`, this.API_KEYS_CONTEXT)
			.pipe(map((response: IResponse) => response.data));
	}

	/** Returns the plaintext key to the caller only. Callers must not persist it. */
	create(body: CreateApiKeyRequest): Observable<CreatedApiKey> {
		return this.http
			.post<IResponse>(`${this.apiUrl}users/me/api-keys`, body, this.API_KEYS_CONTEXT)
			.pipe(map((response: IResponse) => response.data));
	}

	delete(id: string): Observable<string> {
		return this.http
			.delete<IResponse>(`${this.apiUrl}users/me/api-keys/${id}`, this.API_KEYS_CONTEXT)
			.pipe(map((response: IResponse) => response.data));
	}
}
